import { data } from 'react-router';

export function idealistNotFound<T>(body: T): ReturnType<typeof data<T>> {
  return data(body, { status: 404 });
}
